import { r as l, a, i as m, e as p, g as w, S as f, t as g } from "./__packages__deps__web-929faed1.js";
import { R as h } from "./__packages__deps__Relations-38cf0c9f.js";
import { c as y, q as b, g as k } from "./__packages__deps__queryProductByHandle-018098bd.js";
const P = /* @__PURE__ */ g("<h4></h4>"), v = {
  samsonite: "tw-typ-h3-subtopic-1-b tw-font-bold tw-mb-1 tw-uppercase",
  tumi: "tw-typ-h3-subtopic-1-b tw-font-bold tw-mb-1"
}, z = () => {
  const [o] = y(b, {
    handle: window.currentProduct.handle
  }), c = () => {
    var t, e, n;
    return k((n = (e = (t = o()) == null ? void 0 : t.product) == null ? void 0 : e.metafields.find((r) => (r == null ? void 0 : r.key) === "jp_relations")) == null ? void 0 : n.value, "relations");
  }, i = (t) => {
    var r;
    const e = c();
    return e.success ? (r = e.data) == null ? void 0 : r.find((d) => d.name === t) : void 0;
  }, s = () => {
    var t, e, n, r;
    return {
      sku: ((e = (t = o()) == null ? void 0 : t.product) == null ? void 0 : e.variants.nodes[0].sku) || "",
      title: ((r = (n = o()) == null ? void 0 : n.product) == null ? void 0 : r.title) || ""
    };
  };
  return a(f, {
    keyed: !0,
    get when() {
      return o();
    },
    get children() {
      return a(h, {
        filterBy: "product_size",
        get data() {
          var t;
          return [...(t = i("Tamaño")) == null ? void 0 : t.values.map((e) => ({
            title: e.name,
            sku: e.sku
          })), s()];
        },
        get element() {
          return (() => {
            const t = P.cloneNode(!0);
            return m(t, () => {
              var e;
              return (e = window.currentProduct) == null ? void 0 : e.titleSize;
            }), p(() => w(t, v[window.currentProduct.viewModeTitle])), t;
          })();
        },
        get currentProductData() {
          return s();
        }
      });
    }
  });
}, u = document.getElementById("sizes-variations");
u && l(z, u);
